import {useState} from 'react'
import {UploadFile} from 'antd';
import {RcFile} from 'antd/lib/upload';

import {config} from 'config/config';

import apiClient from 'utils/apiClient';
import useHandleError from 'utils/useHandleError';

export const useProgram = () => {
    const [handleError] = useHandleError();
    const [programLoading, setProgramLoading] = useState<boolean>(false)

    const getProgramFiles = async (lectureId: number): Promise<UploadFile[]> => {
        setProgramLoading(true);

        try {
            const response = await apiClient.request(`/api/v1/courses/learning-program/${lectureId}/files`, [], 'GET');

            if (response && response.data && Array.isArray(response.data)) {
                return response.data as UploadFile[];
            }

            throw response;
        } catch (error) {
            handleError(error);
            return [];
        } finally {
            setProgramLoading(false);
        }
    }

    const storeProgramFile = async (programId: number, file: RcFile): Promise<number | undefined> => {
        setProgramLoading(true);

        try {
            const bodyFormData = new FormData();
            bodyFormData.append('file', file);
            const response = await apiClient.request(`/api/v1/courses/learning-program/${programId}/files`, bodyFormData, 'POST');

            if (!!response && typeof response === 'object' && !!response.id) {
                return response.id;
            }

            throw response;

        } catch (error) {
            if (file.size > config.maxUploadFileSize) {
                handleError(error, undefined, 'error.file_too_large');
            } else {
                handleError(error);
            }
        } finally {
            setProgramLoading(false);
        }
    }

    const deleteProgramFile = async (programId: number, id: number): Promise<boolean> => {
        setProgramLoading(true);

        try {
            const response = await apiClient.request(`/api/v1/courses/learning-program/${programId}/files/${id}`, [], 'DELETE');

            if (!!response && !!response.deleted) {
                return true;
            }

            throw response;

        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setProgramLoading(false);
        }
    }

    return {
        programLoading,
        getProgramFiles,
        storeProgramFile,
        deleteProgramFile,
    }
}